<template>
  <Modal
    class="scoped"
    :modal-style="{ maxWidth: '900px' }"
    title="Sources"
  >
    <div class="card q-pa-lg column no-wrap full-height scroll">
      <QSpinner
        v-if="loading"
        class="full-width q-mt-lg"
        :size="30"
      />
      <QList
        v-if="!loading"
        separator
      >
        <QItem v-if="sources['websites'].length">
          <QItemSection class="sources-grid">
            <h3>Websites ({{ sources["websites"].length }})</h3>
            <div
              v-for="website in sources['websites']"
              :key="website.id"
            >
              <RestrictedRouterLink :to="{ path: `/websites/${website.id}` }">
                {{ website.name }}
              </RestrictedRouterLink>
            </div>
          </QItemSection>
        </QItem>
        <QItem v-if="sources['newspapers'].length">
          <QItemSection class="sources-grid">
            <h3>Newspapers ({{ sources["newspapers"].length }})</h3>
            <div
              v-for="newspaper in sources['newspapers']"
              :key="newspaper.id"
            >
              <RestrictedRouterLink
                :to="{ path: `/newspapers/${newspaper.id}` }"
              >
                {{ newspaper.name }}
              </RestrictedRouterLink>
            </div>
          </QItemSection>
        </QItem>
        <QItem v-if="sources['tv_channels'].length">
          <QItemSection class="sources-grid">
            <h3>TV Channels ({{ sources["tv_channels"].length }})</h3>
            <div
              v-for="channel in sources['tv_channels']"
              :key="channel.id"
            >
              <RestrictedRouterLink
                :to="{ path: `/tv-channels/${channel.id}/edit` }"
              >
                {{ channel.name }},
                <span class="soft">{{ channel.location }}</span>
              </RestrictedRouterLink>
            </div>
          </QItemSection>
        </QItem>
        <QItem v-if="sources['radio_stations'].length">
          <QItemSection class="sources-grid">
            <h3>Stations ({{ sources["radio_stations"].length }})</h3>
            <div
              v-for="station in sources['radio_stations']"
              :key="station.id"
            >
              <RestrictedRouterLink
                :to="{ path: `/radio-stations/${station.id}` }"
              >
                {{ station.name }},
                <span class="soft">{{ station.location }}</span>
              </RestrictedRouterLink>
            </div>
          </QItemSection>
        </QItem>
        <QItem v-if="sources['magazines'].length">
          <QItemSection class="sources-grid">
            <h3>Magazines ({{ sources["magazines"].length }})</h3>
            <div
              v-for="magazine in sources['magazines']"
              :key="magazine.id"
            >
              <RestrictedRouterLink :to="{ path: `/magazines/${magazine.id}` }">
                {{ magazine.name }}
              </RestrictedRouterLink>
            </div>
          </QItemSection>
        </QItem>
      </QList>
    </div>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "ViewSourcesModal",
  components: {
    Modal,
  },
  props: {
    sourceGroupId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      sources: [],
    };
  },
  mounted() {
    this.loadSources();
  },
  methods: {
    async loadSources() {
      this.loading = true;

      try {
        this.sources = (
          await this.$streemApiAdmin.get(
            `source_groups/${this.sourceGroupId}/sources`
          )
        ).data;
      } catch {
        this.error = "Loading failed";
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.sources-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
}
</style>
